import { Column } from "../objects/column";
import { SpecialOffer, SpecialOfferForm, SpecialOfferFormLocalization, SpecialOfferListConfiguration, SpecialOfferListCriteria, SpecialOfferListFiltersCriteria } from "../objects/specialOffer";

export const EMPTY_SPECIAL_OFFER_LOCALIZATION: SpecialOfferFormLocalization = {
    condition: '',
    description: '',
    locale: 0,
    title: '',
};
export const EMPTY_SPECIAL_OFFER_FORM: SpecialOfferForm = {
    title: '',
    title_localized: {},
    manual_price: '',
    percentage: '',
    description: '',
    description_localized: {},
    condition: '',
    condition_localized: {},
    price_type: 'FIX',
    localization: [],
    file: null,
    picture: null,
    cms: []
};
export const EMPTY_SPECIAL_OFFER: SpecialOffer = {
    title: '',
    manual_price: '',
    percentage: '',
    description: '',
    condition: '',
    price_type: 'FIX',
    localization: [],
    file: null,
    picture: null,
    cms: [],
};
export const EMPTY_SPECIAL_OFFER_FILTERS: SpecialOfferListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};
export const EMPTY_SPECIAL_OFFER_LIST_CRITERIA: SpecialOfferListCriteria = {
    limit: 50,
    page: 0,
    search: '',
    filters: EMPTY_SPECIAL_OFFER_FILTERS,
    order: "asc",
    order_by: ""
};


export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'allowed-cms',
    field_name: 'ALLOWED_CMS',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_SPECIAL_OFFER_LIST_CONFIGURATION: SpecialOfferListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const SPECIAL_OFFER_MODULE = 'CIRCUIT_SPECIAL_OFFER';


export const getSpecialOfferData = (backend_data: any, current_locale: number): SpecialOfferForm => {
    let has_title = false;
    let has_description = false;
    let has_condition = false;
    const title_localized: Record<number, string> = {};
    const description_localized: Record<number, string> = {};
    const condition_localized: Record<number, string> = {};
    backend_data.localization.map((locale: any) => {
        if (locale.title) {
            has_title = true;
        }
        if (locale.description) {
            has_description = true;
        }
        if (locale.condition) {
            has_condition = true;
        }
        title_localized[locale.locale] = locale.title || "";
        description_localized[locale.locale] = locale.description || "";
        condition_localized[locale.locale] = locale.condition || "";
    });
    if (!has_title) {
        title_localized[Number(current_locale)] = backend_data.title || "";
    }
    if (!has_description) {
        description_localized[Number(current_locale)] = backend_data.description || "";
    }
    if (!has_condition) {
        condition_localized[Number(current_locale)] = backend_data.condition || "";
    }

    return ({
        title: backend_data.title ?? '',
        title_localized,
        manual_price: backend_data.manual_price ?? '',
        percentage: backend_data.percentage ?? '',
        description: backend_data.description ?? '',
        description_localized,
        condition: backend_data.condition ?? '',
        condition_localized,
        id: backend_data.id,
        price_type: (backend_data.percentage !== null ? 'PER' : 'FIX') as 'PER' | 'FIX',
        file: backend_data.file,
        localization: backend_data.localization ?? [],
        picture: backend_data.picture ?? null,
        cms: backend_data.cms ?? []
    });
};